<div class="bg-white border rounded mat-elevation-z2" [ngClass]="tooltipContainerClass">
  <ng-template #simpleText>
    {{ text }}
  </ng-template>
  <ng-container *ngTemplateOutlet="tooltipTemplate || simpleText"></ng-container>
</div>
